import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

const ROW_LINE_HEIGHT = 1.4;

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 520,
		width: '100%',
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	headerIcon: {
		display: 'block',
		flexShrink: 0,
	},
	title: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		marginBottom: SPACE[16],
		marginTop: 0,
	},
	group: {
		marginBottom: SPACE[16],
	},
	groupHeading: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.4,
		margin: 0,
		marginBottom: SPACE[4],
		textTransform: 'uppercase',
	},
	rows: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
		listStyle: 'none',
		margin: 0,
		padding: 0,
	},
	row: {
		alignItems: 'flex-start',
		color: THEME.colors.text.main,
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[8],
		lineHeight: ROW_LINE_HEIGHT,
	},
	// One line box tall, so the icon centres on the first line of a message that wraps.
	rowIconSlot: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		height: `${ROW_LINE_HEIGHT}em`,
	},
	rowIcon: {
		display: 'block',
	},
});
